import {Avatar, CircularProgress, SpeedDial, SpeedDialAction} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import LogoutIcon from '@mui/icons-material/Logout';
import {useAuth} from '../../providers/auth';
import useResetVotes from '../../hooks/useResetVotes';
import {useSnackbar} from 'notistack';

export default function ActionsSpeedDial() {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const {logout, user} = useAuth();
  const {enqueueSnackbar} = useSnackbar();
  const resetVotes = useResetVotes();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleReset = async () => {
    try {
      setLoading(true);
      await resetVotes();
    } catch (error) {
      enqueueSnackbar('Error resetting votes', {variant: 'error'});
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    setLoading(true);
    await logout();
    setLoading(false);
  };

  return (
    <SpeedDial
      ariaLabel="Homepage Actions"
      sx={{position: 'fixed', bottom: 16, right: 16}}
      icon={<Avatar src={user?.profileImage} alt={user?.name} />}
      FabProps={{
        size: 'medium',
        color: 'inherit',
      }}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      <SpeedDialAction
        icon={loading ? <CircularProgress size={20} /> : <DeleteIcon />}
        tooltipTitle="Reset"
        tooltipOpen
        FabProps={{
          disabled: loading,
        }}
        onClick={handleReset}
      />
      <SpeedDialAction
        icon={<LogoutIcon />}
        tooltipTitle="Logout"
        tooltipOpen
        FabProps={{
          disabled: loading,
        }}
        onClick={handleLogout}
      />
    </SpeedDial>
  );
}
